var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white sourcery__dialog-close",attrs:{"fab":"","large":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"color":"black","size":"20"}},[_vm._v(" $chevronRight ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }